

















































































































































import { Component, Vue, Watch } from "vue-property-decorator";

import ReceitaService from "@/service/contabil/ReceitaService";
import { RelatorioReceitaModel } from "@/models/contabil/receita/RelatorioReceitaModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
  },
})
export default class RelatorioReceita extends Vue {
  $refs!: {
    relatorioObserver: InstanceType<typeof ValidationObserver>;
  };

  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  loading = false;

  isMonthly = false;
  months = [
      {name: 1, descricao: 'Janeiro'},
      {name: 2, descricao: 'Fevereiro'},
      {name: 3, descricao: 'Março'},
      {name: 4, descricao: 'Abril'},
      {name: 5, descricao: 'Maio'},
      {name: 6, descricao: 'Junho'},
      {name: 7, descricao: 'Julho'},
      {name: 8, descricao: 'Agosto'},
      {name: 9, descricao: 'Setembro'},
      {name: 10, descricao: 'Outubro'},
      {name: 11, descricao: 'Novembro'},
      {name: 12, descricao: 'Dezembro'},
  ];
  years: number[] = [];
  reportTypes = [
    { name: "DIRF", descricao: "DIRF" },
    { name: "EFD_CONTRIBUICOES", descricao: "EFD Contribuições" },
    { name: "EFD_REINF", descricao: "EFD REINF" },
    { name: "DIMED", descricao: "DIMED" },
  ];
  report: RelatorioReceitaModel = {};

  mounted() {
      const currentYear = new Date().getFullYear();
      for(let i = currentYear - 100; i < currentYear + 100; i++) {
          this.years.push(i);
      }
      this.report.ano = currentYear;
  }

  @Watch("report.tipoRelatorio")
  public changePeriod(): void {
    if (
      this.report.tipoRelatorio === "DIMED" ||
      this.report.tipoRelatorio === "DIRF"
    ) {
      this.isMonthly = false;
    } else {
      this.isMonthly = true;
    }
    console.log(this.isMonthly);
  }

  public gerarRelatorio(tipo: string): void {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        ReceitaService.gerarRelatorio(tipo, this.report)
          .then((res) => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data]));
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              `relatorio_${this.report.tipoRelatorio?.toLowerCase()}.${
                tipo.toLowerCase() === "excel" ? "xls" : "pdf"
              }`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            this.loading = false;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });

        this.limparformulario();
      }
    });
  }

  public limparformulario(): void {
    this.report = {};
    this.$refs.relatorioObserver.reset();
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }
}
